export const environment = {
  // --- HRM UAT -- //
  version: "4.5.9",
  production: false,
  hmr: false,
  regionUrl: 'https://dev-api.fieldex.com/',
  base_url: 'https://dev-api.fieldex.com/custella-0.0.1-SNAPSHOT/api',
  report_url: 'https://dev-api.fieldex.com/report-0.0.1-SNAPSHOT/api',
  webSocket_url: 'https://dev-api.fieldex.com/custella-0.0.1-SNAPSHOT/ws?token=',
  sf_url: 'https://dev-api.fieldex.com/salesforce/connect',
  google_calender_url: 'https://dev-api.fieldex.com/google-calender/connect',
  node_url: 'https://dev-node.fieldex.com:3000/api',
  magnum_node_url: 'https://dev-node.fieldex.com:4000/api',
  active_report_url: 'https://trial-report.fieldex.com/integration?token=',
  touchandgo_node_url: "https://dev-node.fieldex.com:6001/api",
  coffex_node_url: "https://dev-node.fieldex.com:5004/api",
  multiTenant_node_url: "https://dev-node.fieldex.com:3008/api",
  agribio_node_url: "https://dev-node.fieldex.com:3008/api",
  active_report_dashboard_url: "https://trial-report.fieldex.com",
  ms_base_url: "https://dev-api.fieldex.com/custella-0.0.1-SNAPSHOT/api/ms",
  ms_node_base_url: "https://dev-api.fieldex.com/machine-0.0.1-SNAPSHOT/api/",
  ai_base_url: "https://dev-ai.fieldex.com",
  environment_name: "trial",
  reseller_url:
    "https://trial-poc-api.fieldex.com/management-portal-0.0.1-SNAPSHOT/api/",
  mixpanelToken: "465e46f104355f0b7b75e4e15b22ca5a", // Replace with your actual Mixpanel Project token
  fieldexPortalUrl: "https://management-portal-trial.fieldex.com/", // Replace with your actual Customer.io API ID
  intercomAppId: "yamghbfx", // Replace with your actual Intercom App ID
  mansorIframeUrl: "https://masor-dev.fieldex.com/?token=",
  qrFromUrl: "https://dev-maintenance.fieldex.com/",
  siteQrFromUrl: "https://dev-site.fieldex.com/",
  customerPortalDomain: "fieldex.info"
};